import { useMemo } from 'react';
import { AccordionData, ProcessedFAQData } from '@contracts';

function useAccordionProcessedFaqs(processedFaqs: ProcessedFAQData[]): AccordionData[] {
  const accordionData: AccordionData[] = useMemo(() => {
    return processedFaqs.reduce((result: AccordionData[], processedFaq) => {
      const questionText = processedFaq?.questionText;
      const answerText = processedFaq?.answerText;

      if (questionText) {
        result.push({
          title: questionText,
          prismicContent: answerText.map((block) => block.text).join('\n'),
          prismicHtmlContent: answerText
        });
      }

      return result;
    }, [] as AccordionData[]);
  }, [processedFaqs]);

  return accordionData;
}

export default useAccordionProcessedFaqs;
